var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessmentEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.77 1.791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.809,1061.842a.211.211,0,0,0-.211.211v1.871a.633.633,0,0,1-.632.632h-5.913a.633.633,0,0,1-.632-.632v-5.491a.633.633,0,0,1,.632-.632h1.871a.211.211,0,0,0,0-.422h-1.871a1.055,1.055,0,0,0-1.054,1.054v5.491a1.055,1.055,0,0,0,1.054,1.054h5.913a1.055,1.055,0,0,0,1.054-1.054v-1.871a.211.211,0,0,0-.211-.211Zm0,0",
    transform: "translate(-362 -1056.559)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.706,1018.8a.948.948,0,0,0-1.341,0l-3.759,3.759a.211.211,0,0,0-.054.093l-.494,1.785a.211.211,0,0,0,.259.259l1.785-.495a.21.21,0,0,0,.093-.054l3.759-3.76a.949.949,0,0,0,0-1.341Zm-4.641,3.9,3.077-3.077.992.992-3.077,3.077Zm-.2.4.793.793-1.1.3Zm4.789-3-.223.223-.992-.992.224-.223a.527.527,0,0,1,.745,0l.247.247a.527.527,0,0,1,0,.745Zm0,0",
    transform: "translate(-467.769 -1018.521)",
    fill: "#6e6e6e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentEdit);
export default __webpack_public_path__ + "static/media/assessment_edit.272a04b4.svg";
export { ForwardRef as ReactComponent };